import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Location } from './types'

export const CREATE_LOCATION: TypedDocumentNode<
  { createLocation: Location },
  {
    client_id: string
    application_id: string
    name: string
    address?: string | null
    subtitle?: string | null
    description?: string | null
    image?: string | null
    observations?: string | null
    sort_order?: number | null
  }
> = gql`
  mutation CreateLocation($client_id: ID!, $application_id: ID!, $name: String!, $address: String, $subtitle: String, $description: String, $image: String, $observations: String, $sort_order: Int) {
    createLocation(client_id: $client_id, application_id: $application_id, name: $name, address: $address, subtitle: $subtitle, description: $description, image: $image, observations: $observations, sort_order: $sort_order) {
      id client_id application_id name address subtitle description image image_low_res observations sort_order created_at updated_at
    }
  }
`

export const UPDATE_LOCATION: TypedDocumentNode<
  { updateLocation: Location },
  {
    id: string
    name?: string
    address?: string | null
    subtitle?: string | null
    description?: string | null
    image?: string | null
    observations?: string | null
    sort_order?: number | null
  }
> = gql`
  mutation UpdateLocation($id: ID!, $name: String, $address: String, $subtitle: String, $description: String, $image: String, $observations: String, $sort_order: Int) {
    updateLocation(id: $id, name: $name, address: $address, subtitle: $subtitle, description: $description, image: $image, observations: $observations, sort_order: $sort_order) {
      id client_id application_id name address subtitle description image image_low_res observations sort_order created_at updated_at
    }
  }
`

export const DELETE_LOCATION: TypedDocumentNode<{ deleteLocation: boolean }, { id: string }> = gql`
  mutation DeleteLocation($id: ID!) {
    deleteLocation(id: $id)
  }
`
